import React from "react";

function Taurus() {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 496.159 496.159"
      enableBackground="new 0 0 496.159 496.159"
    >
      <path
        fill="#AF8D4A"
        d="M248.083,0.003C111.071,0.003,0,111.063,0,248.085c0,137.001,111.07,248.07,248.083,248.07
	c137.006,0,248.076-111.069,248.076-248.07C496.159,111.062,385.089,0.003,248.083,0.003z"
      />
      <path
        fill="#EAE7D0"
        d="M167.373,199.371c-15.639,5.093-30.906,0.336-40.461-6.388c-9.556-6.724-20.828-23.321-18.077-47.33
	c4.961-43.284,47.094-43.202,47.094-43.202c-13.176-11.316-31.91-8.684-39.008-6.011c-41.625,15.681-50.474,61.879-50.474,61.879
	c-9.358,77.235,95.644,85.017,95.644,85.017c55.194-2.04,60.517-62.722,60.517-62.722
	C198.449,182.302,167.373,199.371,167.373,199.371z"
      />
      <path
        fill="#DDD9BF"
        d="M167.373,199.371C96.288,209.421,66.448,158.32,66.448,158.32
	c-9.358,77.235,95.644,85.017,95.644,85.017c55.194-2.04,60.517-62.722,60.517-62.722
	C198.449,182.302,167.373,199.371,167.373,199.371z"
      />
      <path
        fill="#EAE7D0"
        d="M428.251,158.32c0,0-8.849-46.198-50.474-61.879c-7.098-2.673-25.832-5.305-39.008,6.011
	c0,0,42.133-0.082,47.094,43.202c2.752,24.009-8.521,40.606-18.076,47.33s-24.822,11.48-40.461,6.388
	c0,0-31.076-17.069-55.235-18.756c0,0,5.323,60.682,60.517,62.722C332.607,243.337,437.609,235.555,428.251,158.32z"
      />
      <path
        fill="#DDD9BF"
        d="M428.251,158.32c0,0-29.84,51.101-100.925,41.051c0,0-31.076-17.069-55.235-18.756
	c0,0,5.323,60.682,60.517,62.722C332.607,243.337,437.609,235.555,428.251,158.32z"
      />
      <path
        fill="#4C4A48"
        d="M367.007,244.183c-23.533-3.177-46.177,11.646-46.177,19.002c0,7.355,8.18,23.02,39.815,28.133
	c23.533,3.177,46.178-20.778,46.178-28.133C406.823,255.829,390.54,247.358,367.007,244.183z"
      />
      <path
        fill="#383736"
        d="M360.958,253.385c-14.313-1.933-28.085,7.083-28.085,11.557s4.976,14,24.216,17.111
	c14.313,1.932,28.085-12.638,28.085-17.111S375.271,255.316,360.958,253.385z"
      />
      <path
        fill="#4C4A48"
        d="M131.202,244.183c-23.533,3.176-39.816,11.646-39.816,19.002c0,7.355,22.645,31.31,46.178,28.133
	c31.635-5.113,39.816-20.778,39.816-28.133C177.38,255.829,154.735,241.006,131.202,244.183z"
      />
      <path
        fill="#383736"
        d="M137.251,253.385c-14.313,1.932-24.216,7.083-24.216,11.557s13.772,19.042,28.085,17.111
	c19.24-3.11,24.216-12.638,24.216-17.111S151.564,251.452,137.251,253.385z"
      />
      <path
        fill="#3F3D3D"
        d="M333.445,256.518c0,0,10.828-22.088,4.332-32.483c0,0-7.796-6.063-19.49-7.796
	c0,0-39.702-22.497-69.281-22.497c-29.579,0-69.28,22.497-69.28,22.497c-11.693,1.733-19.49,7.796-19.49,7.796
	c-6.496,10.395,4.332,32.483,4.332,32.483c2.165,8.662-2.166,26.853-2.166,26.853c-4.764,31.617,34.648,107.411,34.648,107.411
	c3.464,6.063,18.181,48.385,51.955,48.385s48.492-42.321,51.956-48.385c0,0,39.414-75.794,34.649-107.411
	C335.61,283.371,331.28,265.18,333.445,256.518z"
      />
      <path
        fill="#514F4D"
        d="M318.286,216.239c0,0-39.702-22.497-69.281-22.497s-69.28,22.497-69.28,22.497
	c-6.338,0,18.768,54.717,18.768,54.717l12.561,89.764c3.464,6.063,4.177,78.447,37.951,78.447s35.918-74.384,39.382-80.447
	l11.132-87.764C299.519,270.956,322.887,216.239,318.286,216.239z"
      />
      <path
        fill="#444341"
        d="M179.725,216.239c-5.588,0,18.768,54.717,18.768,54.717l12.561,89.764
	c3.464,6.063,4.177,78.447,37.951,78.447V193.742C219.426,193.742,179.725,216.239,179.725,216.239z"
      />
      <path
        fill="#383736"
        d="M247.76,356.407c-54.905,0-55.357,22.006-55.357,22.006c1.641,12.993,2.818,27.338,4.647,32.916
	c1.829,5.578,17.04,29.55,51.955,29.55c34.916,0,49.02-22,51.956-29.55c2.937-7.549,3.007-19.923,4.648-32.916
	C305.609,378.413,302.665,356.407,247.76,356.407z"
      />
      <g>
        <path
          fill="#161616"
          d="M216.35,381.192c-14.065,45.506,26.477,33.923,26.477,33.923
		C225.704,409.488,216.35,381.192,216.35,381.192z"
        />
        <path
          fill="#161616"
          d="M284.665,381.192c0,0-9.354,28.296-26.477,33.923C258.189,415.115,298.731,426.698,284.665,381.192z
		"
        />
      </g>
      <g>
        <path
          fill="#282727"
          d="M183.768,234.863l-25.121-0.867c0,0-1.733,1.877-0.29,10.973c1.444,9.096,6.209,11.549,6.209,11.549
		l33.926,14.438l2.021-3.466L183.768,234.863z"
        />
        <path
          fill="#282727"
          d="M339.364,233.996l-25.121,0.867l-16.747,32.627l2.022,3.466l33.926-14.438
		c0,0,4.764-2.454,6.208-11.549C341.097,235.873,339.364,233.996,339.364,233.996z"
        />
      </g>
      <path
        fill="#494949"
        d="M339.364,233.996l-0.048,0.002c0.465,1.432,0.77,2.974,0.909,4.582
	C340.207,234.924,339.364,233.996,339.364,233.996z"
      />
      <path
        fill="#383736"
        d="M316.381,197.175c-8.732-9.666-35.981-18.272-67.847-18.272c-29.389,0-55.285,4.57-66.128,15.725
	c-3.477,3.577-5.406,23.848-5.406,23.848c0,12.046,142.308,12.046,142.308,0C319.308,218.475,318.284,199.282,316.381,197.175z"
      />
      <path
        fill="#2D2D2D"
        d="M248.534,178.903c-29.389,0-55.285,4.57-66.128,15.725c-3.477,3.577-5.406,23.848-5.406,23.848
	c0,6.074,36.18,9.085,72.055,9.034L248.534,178.903z"
      />
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
}

export default Taurus;
